import Input from '@material-ui/core/Input'
import React from 'react'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'
const ListNumericInputStyle = styled.div`
  input {
    text-align: right;
  }
`

class ListNumericInput extends React.Component {
  state = {
    isUnderline: false,
  }

  NumberFormatCustom = props => {
    const { inputRef, onChange, ...other } = props
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.floatValue,
            },
          })
        }}
        thousandSeparator=" "
        decimalSeparator=","
        isNumericString={true}
        decimalScale={this.props.czyKwotyWTysiacach ? 0 : 2}
        fixedDecimalScale={true}
      />
    )
  }

  handleClick(e) {
    let v = e.target.value
    if (v === '0' || v === '0,00') e.target.select()
  }

  render() {
    return (
      <ListNumericInputStyle>
        <Input
          inputProps={{
            'data-cy': 'numeric-input',
            onClick: this.handleClick,
          }}
          name={this.props.name}
          value={this.props.value}
          placeholder={
            this.props.placeholder ? this.props.placeholder : 'Podaj opis'
          }
          onFocus={() => this.toggleUnderline()}
          onBlur={() => this.toggleUnderline()}
          disableUnderline={!this.state.isUnderline}
          onChange={c => this.props.onValueChange(c.target.value)}
          id="formatted-text-mask-input"
          inputComponent={this.NumberFormatCustom}
          autoComplete="off"
        />
      </ListNumericInputStyle>
    )
  }

  toggleUnderline() {
    this.setState({ isUnderline: !this.state.isUnderline })
  }
}

export default ListNumericInput
